// src/components/Button.jsx

import React from 'react';
import { Button as BsButton } from 'react-bootstrap';

// Прокидываем type="button" по умолчанию и все пропсы
export default function Button({
  children,
  variant = 'primary',
  onClick,
  type = 'button',
  className = '',
  ...rest
}) {
  return (
    <BsButton
      type={type}
      variant={variant}
      onClick={onClick}
      className={className}
      {...rest}
    >
      {children}
    </BsButton>
  );
}
